import React, { useMemo } from 'react';
import { Button, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import router from '../router';
import { useAppSelector } from '../redux/hooks';
import DocumentList from '../components/documents/DocumentList';
import DocumentDeleteAction from '../components/documents/actions/DocumentDeleteAction';
import DocumentDetailsAction from '../components/documents/actions/DocumentDetailsAction';
import DocumentSetTabs from '../components/documents/DocumentSetTabs';
import DocumentSetFilter from '../components/documents/DocumentSetFilter';
import { Document } from '../types';

const DocumentsListPage: React.FC = () => {
    // Set-based documents (from documentSetSlice)
    const setDocuments = useAppSelector((s) => s.documentSet.documents);
    const loading = useAppSelector((s) => s.documentSet.loading);

    // Map DocumentLight → Document shape for DocumentList compatibility
    const documents: Document[] = useMemo(
        () =>
            setDocuments.map((d) => ({
                id: d.id,
                title: d.title,
                description: d.description ?? null,
                documentTypeId: d.documentTypeId,
                documentTypeCode: '',
                createdAt: d.createdAt,
                updatedAt: d.updatedAt,
                isLocked: false,
                lockedByUserId: null,
                lockedAt: null,
                details: [],
                detailsLoaded: false,
            })),
        [setDocuments]
    );

    const handleDoubleClick = async (documentId: string) => {
        await router.navigate(`/documents/${documentId}`);
    };

    const handleAddNew = async () => {
        await router.navigate('/documents/new');
    };

    return (
        <div className="documents-list-container">
            <div className="flex justify-between items-center pb-3 h-16">
                <h2 className="text-xl">Список документов</h2>
                <Button type="primary" onClick={handleAddNew} icon={<PlusOutlined />}>
                    Добавить документ
                </Button>
            </div>

            {/* Tab switcher — triggers fetch on mount and on tab change */}
            <DocumentSetTabs />

            {/* Admin-only owner filter */}
            <DocumentSetFilter />

            {loading ? (
                <div className="flex justify-center items-center h-full">
                    <Spin size="large" />
                </div>
            ) : (
                <DocumentList
                    documents={documents}
                    actions={(document) => [
                        <DocumentDetailsAction
                            key="details"
                            document={document}
                            onDetails={handleDoubleClick}
                        />,
                        <DocumentDeleteAction
                            key="delete"
                            document={document}
                        />,
                    ]}
                    style={{ height: 'calc(100vh - 220px)' }}
                    offset={0}
                />
            )}
        </div>
    );
};

export default DocumentsListPage;
